import styled from 'styled-components';

const Text = styled.span`
  text-transform: ${(props) => (props.capitalize ? 'capitalize' : 'none')};
`;

export default Text;
